<template>
  <div class="add-product">
    <el-dialog
      :title="isEdit?$t('payment_links.edit_product'):$t('payment_links.add_new_product')"
      :visible.sync="dialogVisible"
      width="660px"
      :close-on-click-modal="false"
      :before-close="clickCancel"
    >
      <div class="title">
        {{ $t('payment_links.product_info') }}
      </div>
      <el-form ref="form" label-width="250px" :model="form" :rules="rules" label-position="left">
        <el-form-item prop="name" :label="$t('payment_links.product_name')" required>
          <el-input v-model="form.name" maxlength="128" :placeholder="$t('payment_links.product_name')" class="from-input" size="small" type="text" clearable />
        </el-form-item>

        <el-form-item prop="price" :label="$t('payment_links.price')" required>
          <el-input v-model.trim="form.price" :placeholder="$t('payment_links.price')" class="from-input" size="small" type="text" clearable />
        </el-form-item>

        <el-form-item prop="pic" :label="$t('payment_links.image')">
          <el-upload
            v-loading="uploadLoading"
            action="#"
            list-type="picture-card"
            :auto-upload="false"
            :file-list="fileList"
            :limit="1"
            :on-change="handleImageChange"
            :class="{'hideUploadFlag': isHideUpdate,'upload-image':true}"
          >
            <div v-show="!isHideUpdate" slot="default">
              <el-button type="primary" size="small">
                {{ $t('components.click_to_upload') }}
              </el-button>
            </div>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in" />
                </span>
                <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                  <i class="el-icon-delete" />
                </span>
              </span>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>

      <div class="dialog-footer">
        <el-button @click="clickCancel">{{ $t('components.cancel') }}</el-button>
        <el-button type="info" :disabled="submitLoading" class="btn-submit" @click="clickSubmit">{{
          $t('components.submit')
        }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogImageVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { uploadImg } from '@/api/components/upload'
import { mchCreateProduct, mchUpdateProduct } from '@/api/payment-link/payment-link'
export default {
  name: 'Add_New_Proudct',
  components: { },
  data() {
    const checkAmount = (rule, value, callback) => {
      value = Number(value)
      if (value <= 0 || isNaN(value)) {
        return callback(new Error('Please enter a non-negative number'))
      }
      if (value > 2000000) {
        return callback(new Error('Price is too large'))
      }
      if (this.$store.getters.isVnMerchant) {
        // 越南只允许整数金额，无专门上下限
        if (!/^[1-9]\d*$/.test(String(value))) {
          return callback(new Error('Please enter a valid integer amount'))
        }
      }
      if (!/^(0|[1-9]\d*)(.\d{1,2})?$/.test(value)) {
        return callback(new Error('Please enter two decimal places'))
      }
      callback()
    }
    return {
      sub_merchant_no: this.$route.params.sub_merchant_no,
      dialogVisible: false, // 控制弹框显示隐藏
      uploadLoading: false,
      submitLoading: false,
      dialogImageVisible: false,
      isEdit: false,
      isEditPic: false, // 编辑图片
      dialogImageUrl: '',
      form: {
      },
      fileList: [],
      rules: {
        price: [
          { required: true, message: 'Price cannot be empty' },
          { validator: checkAmount, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    isHideUpdate() {
      return this.fileList && this.fileList.length > 0
    }
  },
  methods: {
    // 改变弹框状态
    changModalStatus(value, row) {
      this.dialogVisible = value
      this.isEdit = !!row
      if (this.isEdit) {
        this.form = Object.assign({}, row)
        this.form.price = this.$commonFn.mathDivide(Number(this.form.price), 100)
        this.fileList = row.pic ? [{ url: row.pic }] : []
      }
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter(item => item.uid !== file.uid)
      this.form.pic = ''
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogImageVisible = true
    },
    handleImageChange(file, fileList) {
      this.fileList = []

      if (this.uploadLoading) {
        this.$message.warning('Uploading, pls wait!')
        return
      }

      this.uploadLoading = true
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('business', 'MERCHANT_PAYMENT_LINK_FILE')
      formData.append('public', true)
      uploadImg(formData).then(res => {
        this.$message.success('Image upload successfully!')
        this.$refs.form.clearValidate('pic')
        this.$set(this.form, 'pic', res.data.path)
        this.isEditPic = true
        this.fileList = [file]
      }).finally(() => {
        this.uploadLoading = false
      })
    },
    clickSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const request = this.isEdit ? mchUpdateProduct : mchCreateProduct
          const { price, pic, ...otherSearch } = this.form
          const params = {
            sub_merchant_no: this.sub_merchant_no,
            price: this.$commonFn.mathMultiply(Number(price), 100),
            ...otherSearch
          }
          if (this.isEditPic) {
            params.pic = pic
          }
          request(params).then(res => {
            this.$emit('clearProduct')
            this.$message.success('Success')
            this.initForm()
            this.isEditPic = false
            this.dialogVisible = false
          })
        }
      })
    },
    clickCancel() {
      this.initForm()
      this.dialogVisible = false
    },
    initForm() {
      this.fileList = []
      this.form = {}
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped lang="scss">
.add-product{
  ::v-deep .el-upload--picture-card{
    background: none;
    width: auto;
    height: auto;
    line-height: normal;
    border: none;
  }
  .upload-image{
    display: inline-block;
  }
  ::v-deep .el-dialog__header{
    padding: 12px 24px;
    height: 48px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.20);
    .el-dialog__headerbtn{
      top: 16px;
    }
    span{
      color: #1B4AEF;
      font-size: 16px;
      font-family: Inter;
      font-weight: 600;
    }
  }
  ::v-deep .el-dialog__body{
    padding: 24px;
    .el-form-item__label{
      font-family: Inter;
      font-weight: 600;
    }
  }
  .title{
    color: #1D3A71;
    font-family: Inter;
    font-size: 20px;
    font-weight: 600;
    padding-bottom: 12px;
  }
  .from-input{
    width: 240px;
  }
  .dialog-footer{
    text-align: right;
  }
}
</style>
